'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeUndefinedValuesFromList = exports.matchComponentsToSectionLayout = exports.createComponentsWithProps = exports.getDefinedSectionComponentTypes = exports.getSections = exports.isDefined = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _fishrmnTypes = require('@fishrmn/fishrmn-types');

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/*
* GENERAL UTILITIES
* */

var isDefined = function isDefined(val) {
  if (Array.isArray(val)) return val.length > 0;else if ((typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object') return Object.keys(val).length > 0;else if (typeof val === 'number') return val === 0 ? true : val;
  return val;
};

var removeUndefinedValuesFromList = function removeUndefinedValuesFromList(list) {
  var cleanedList = list.filter(function (item) {
    return isDefined(item);
  });
  return cleanedList;
};

var isSublist = function isSublist(sublist, greaterList) {
  var isSublistBool = sublist.map(function (item) {
    return greaterList.includes(item);
  }).every(function (item) {
    return item;
  });
  return isSublistBool;
};

/*
* SECTION LAYOUT UTILITIES
* */

var getSections = function getSections(sectionTypes) {
  var sections = sectionTypes.map(function (type) {
    if (typeof type === 'string') return _fishrmnTypes.sectionLayoutTypes[type];
    return type;
  }).filter(function (sectionLayout) {
    return sectionLayout;
  });
  return sections;
};

var getAllComponentLayouts = function getAllComponentLayouts(sectionLayouts) {
  var componentLayouts = sectionLayouts.reduce(function (acc, layout) {
    return [].concat(_toConsumableArray(acc), _toConsumableArray(layout.componentLayouts));
  }, []);
  return componentLayouts;
};

var matchComponentsToSectionLayout = function matchComponentsToSectionLayout(sectionComponentTypes, sectionLayouts) {
  // Find all section layouts where all component types are defined
  var definedSectionComponentTypeNames = sectionComponentTypes.map(function (sectionComponentType) {
    return sectionComponentType.type;
  });
  var matchedSectionLayouts = sectionLayouts.filter(function (sectionLayout) {
    return isSublist(sectionLayout.definedComponentTypes, definedSectionComponentTypeNames);
  });

  // If no matches
  if (matchedSectionLayouts.length === 0) return false;

  // Get matched section layout with the most components to fill the page
  var matchedSectionLayoutMostComponents = matchedSectionLayouts.reduce(function (a, b) {
    return a.definedComponentTypes.length > b.definedComponentTypes.length ? a : b;
  });
  return matchedSectionLayoutMostComponents;
};

/*
* COMPONENT PROP UTILITIES
* */

var createComponentProp = function createComponentProp(componentProps, path, value) {
  var newObj = _extends({}, componentProps);
  if (path.length === 1) {
    newObj[path[0]] = value;
    return newObj;
  }
  newObj[path[0]] = createComponentProp(isDefined(newObj[path[0]]) ? newObj[path[0]] : {}, path.slice(1, path.length + 1), value);
  return newObj;
};

var createComponentProps = function createComponentProps(componentLayout, componentData) {
  var componentName = componentLayout.componentName,
      propFieldsMap = componentLayout.propFieldsMap;
  var fixedProps = _fishrmnTypes.componentTypes[componentName].fixedProps;

  var propFieldKeys = Object.keys(propFieldsMap);

  var componentProps = {};
  propFieldKeys.forEach(function (propFieldKey) {
    var keyPath = propFieldsMap[propFieldKey].split('_');
    componentProps = createComponentProp(componentProps, keyPath, componentData[propFieldKey]);
  });

  return _extends({}, componentProps, fixedProps);
};

var areComponentPropsDefined = function areComponentPropsDefined(componentType, componentData) {
  var type = componentType.type,
      propsMap = componentType.propsMap;

  var requiredComponentProps = _fishrmnTypes.componentTypes[type].requiredProps;
  var propsMapKeys = Object.keys(propsMap);
  var definedComponentPropKeys = propsMapKeys.filter(function (propsKey) {
    return isDefined(componentData[propsKey]);
  });
  var definedComponentPropsMappedNames = definedComponentPropKeys.map(function (definedKey) {
    return propsMap[definedKey];
  });

  return definedComponentPropsMappedNames.length >= requiredComponentProps.length;
};

var createComponentsWithProps = function createComponentsWithProps(matchedSectionLayout, componentData) {
  var componentLayouts = matchedSectionLayout.componentLayouts;

  var componentsWithProps = componentLayouts.map(function (componentLayout) {
    var component = _fishrmnTypes.componentTypes[componentLayout.componentName];
    var componentProps = createComponentProps(componentLayout, componentData);
    return {
      component: component.getComponent(componentProps),
      type: componentLayout.componentName
    };
  });
  return componentsWithProps;
};

/*
* COMPONENT TYPE UTILITIES
* */

var createComponentTypes = function createComponentTypes(componentLayouts) {
  var componentTypes = componentLayouts.map(function (componentLayout) {
    return {
      type: componentLayout.componentName,
      propsMap: componentLayout.propFieldsMap
    };
  });
  return componentTypes;
};

var getUniqueComponentTypes = function getUniqueComponentTypes(componentTypes) {
  var uniqueComponentTypesMap = new Map();
  var uniqueComponentTypes = [];

  componentTypes.forEach(function (componentType) {
    return uniqueComponentTypesMap.set(componentType.type, componentType.propsMap);
  });
  var componentTypesMapEntries = uniqueComponentTypesMap.entries();

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = componentTypesMapEntries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _step$value = _slicedToArray(_step.value, 2),
          key = _step$value[0],
          value = _step$value[1];

      uniqueComponentTypes.push({ type: key, propsMap: value });
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return uniqueComponentTypes;
};

var getSectionComponentTypes = function getSectionComponentTypes(layouts) {
  var componentLayouts = getAllComponentLayouts(layouts);
  var componentTypes = createComponentTypes(componentLayouts);
  var uniqueComponentTypes = getUniqueComponentTypes(componentTypes);

  return uniqueComponentTypes;
};

var getDefinedSectionComponentTypes = function getDefinedSectionComponentTypes(layouts, componentData) {
  // Get all components for this section's layouts
  var sectionComponentTypes = getSectionComponentTypes(layouts);

  // Get all defined components from the list of all components
  var definedSectionComponentTypes = sectionComponentTypes.filter(function (componentType) {
    return areComponentPropsDefined(componentType, componentData);
  });
  return definedSectionComponentTypes;
};

exports.isDefined = isDefined;
exports.getSections = getSections;
exports.getDefinedSectionComponentTypes = getDefinedSectionComponentTypes;
exports.createComponentsWithProps = createComponentsWithProps;
exports.matchComponentsToSectionLayout = matchComponentsToSectionLayout;
exports.removeUndefinedValuesFromList = removeUndefinedValuesFromList;